<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <h1 class="title mb-3">My Meetings</h1>
        <b-tabs content-class="mt-3" fill>
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :title="tab.title"
            :active="tab.label === activeTab.tab"
            @click="selectTab(tab)"
          >
            <div class="row">
              <div class="col-6">
                <span class="result-Text"
                  >{{ pageStart }} - {{ pageEnd }} of {{ total }}</span
                >
              </div>
              <NCD searchKey="date" label="Meeting Date"/>
            </div>
            <div class="card" :class="{ filterDate: tab.label === 'custom' }">
              <div
                class="card-header text-center pt-0 pb-0"
                v-if="tab.label === 'custom'"
              >
                <div class="row">
                  <span class="col-6 border-right p-2" @click="showStart = true"
                    >{{ startDateOutput }} <img src="@/assets/caret.svg" alt=""
                  /></span>
                  <span class="col-6 p-2" @click="showEnd = true"
                    >{{ endDateOutput }} <img src="@/assets/caret.svg" alt=""
                  /></span>
                </div>
              </div>
              <div
                class="card-body p-3 card-message"
                v-if="meetings.length === 0"
              >
                <img src="@/assets/message-icon.svg" alt="" />
                <span class="info">No meetings</span>
              </div>
              <router-link
                :to="{ name: 'MeetingDetails', params: { id: meeting.uuid } }"
                tag="div"
                class="card-body p-3"
                v-else
                v-for="(meeting, index) in meetings"
                :key="index"
              >
                <div class="">
                  <div class="row">
                    <div class="col-7 pr-0 mt-1">
                      <h3 class="broker-name">{{ meeting.name }}</h3>
                      <span class="firm-name">{{ meeting.firm_name }}</span>
                        <span class="mt-2 emp-Name" v-if="meeting.user_full_name"> {{meeting.user_full_name}} </span>
                    </div>
                    <div class="col-5 pl-0 text-right">
                      <span class="label-status-sm"> {{meeting.lead_status_name}} </span>
                      <span class="date" v-if="meeting.meeting_date">
                        <i class="icon-calender">
                          <img src="@/assets/calender.svg" alt="" />
                        </i>
                        {{ meeting.meeting_date }}
                        <i class="icon-arrowr">
                          <img src="@/assets/right-arrow.svg" alt="" />
                        </i>
                      </span>

                    </div>
                  </div>

                </div>
              </router-link>
            </div>
          </b-tab>
        </b-tabs>
      </b-container>
      <paginate
        v-if="totalPages > 1"
        v-model="pageNo"
        :page-count="totalPages"
        :click-handler="goToPage"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
        :container-class="'pagination justify-content-center'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
      >
      </paginate>
    </div>
    <router-link :to="{ name: 'NewMeeting' }" class="btn-float"><i class="icon-add">+</i></router-link>
    <vue-bottom-dialog v-model="showStart" :height="450">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <h2 class="ml-2">Select Date</h2>
          </div>
          <div class="col-6 text-right">
            <a class="outline-default mr-3" @click="showStart = false">
              Cancel
            </a>
            <a
              class="outline-default outline-default-primary"
              @click="performSelectStart"
            >
              Save
            </a>
          </div>
          <div class="col-12">
            <div class="wrapper-radio-calender">
              <b-form-group>
                <b-calendar
                  block
                  v-model="startDateOutput"
                  locale="en-US"
                  @input="selectStart"
                  placeholder="Start date"
                ></b-calendar>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-dialog>
    <vue-bottom-dialog v-model="showEnd" :height="450">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <h2 class="ml-2">Select Date</h2>
          </div>
          <div class="col-6 text-right">
            <a class="outline-default mr-3" @click="showEnd = false">
              Cancel
            </a>
            <a
              class="outline-default outline-default-primary"
              @click="performSelectEnd"
            >
              Save
            </a>
          </div>
          <div class="col-12">
            <div class="wrapper-radio-calender">
              <b-form-group>
                <b-calendar
                  block
                  v-model="endDateOutput"
                  locale="en-US"
                  @input="selectEnd"
                  placeholder="Start date"
                ></b-calendar>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-dialog>
  </div>
</template>
<script>
import { paramsFromQuery } from "@/assets/scripts/utility.js";
import NCD from '@/components/Common/Ncd.vue';
import qs from "qs";

export default {
  name: "Meetings",
  components: {
    NCD
  },
  data() {
    return {
      showStart: false,
      showEnd: false,
      sameNavigation: false,
      total: 0,
      perPage: 0,
      startDateOutput: "Start Date",
      endDateOutput: "End Date",
      meetings: [],
      tabs: [
        { label: "thisweek", title: "Last 7 Days", sDiff: 7, eDiff: 0 },
        { label: "thismonth", title: "Last 30 Days", sDiff: 30, eDiff: 0 },
        { label: "custom", title: "Custom Date", sDiff: null, eDiff: null },
      ],
    };
  },
  computed: {
    activeTab() {
      return this.$store.getters.sDefaults;
    },
    customDefault() {
      return this.$store.getters.customDefault;
    },
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    },
  },
  created() {
    this.startDateOutput = this.$moment()
      .subtract(this.customDefault.start, "d")
      .format("YYYY-MM-DD");
    this.endDateOutput = this.$moment()
      .subtract(this.customDefault.end, "d")
      .format("YYYY-MM-DD");
    let defT = this.activeTab;
    let defTObj = this.tabs.find((k) => k.label === defT.tab);
    this.selectTab(defTObj);
  },
  watch: {
    $route(to, from) {
      this.loadData();
    },
  },
  methods: {
    selectStart(date) {
      let diff = this.diffFromDate(date);
      this.customDefault.start = diff;
    },
    selectEnd(date) {
      let diff = this.diffFromDate(date);
      this.customDefault.end = diff;
    },
    performSelectStart() {
      this.showStart = false;
      let defTObj = this.tabs.find((k) => k.label === "custom");
      this.selectTab(defTObj);
    },
    performSelectEnd() {
      this.showEnd = false;
      let defTObj = this.tabs.find((k) => k.label === "custom");
      this.selectTab(defTObj);
    },
    selectTab(tab) {
      let startDate, endDate;
      this.activeTab.tab = tab.label;
      if (tab.sDiff !== null) {
        startDate = this.$moment().subtract(tab.sDiff, "d");
      } else {
        startDate = this.$moment().subtract(this.customDefault.start, "d");
      }
      if (tab.eDiff !== null) {
        endDate = this.$moment().subtract(tab.eDiff, "d");
      } else {
        endDate = this.$moment().subtract(this.customDefault.end, "d");
      }
      this.activeTab.startDate = startDate;
      this.activeTab.endDate = endDate;
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {} });
      }
      this.loadData();
    },
    loadData() {
      this.meetings = [];
      let queryP = {};
      paramsFromQuery(queryP, this.$route.query);
      if (this.activeTab.startDate && this.activeTab.endDate) {
        let dateTo = this.activeTab.endDate.format("YYYY-MM-DD");
        let dateFrom = this.activeTab.startDate.format("YYYY-MM-DD");
        let searchDataUrl = new URLSearchParams({
          meeting_from: dateFrom,
          meeting_upto: dateTo,
        }).toString();
        let url = `meetings?${searchDataUrl}`;
        this.$axios
          .get(url, {
            params: queryP,
            paramsSerializer: (params) =>
              qs.stringify(params, { arrayFormat: "brackets" }),
          })
          .then((res) => {
            this.meetings = res.data.meetings;
            this.perPage = res.data.per_page;
            this.total = res.data.count;
            console.log(this.total);
          })
          .catch((err) => console.log(err));
      }
    },
    diffFromDate(date) {
      let diff = this.$moment()
        .startOf("day")
        .diff(this.$moment(date, "YYYY-MM-DD").startOf("day"), "day");
      return diff;
    },
    goToPage(pageNo) {
      let newQ = { ...this.$route.query, pageNo };
      this.$router.replace({ query: newQ });
    },
  },
};
</script>
<style scoped>
.filterDate {
  margin-top: -5px;
}
</style>